module.exports = __webpack_public_path__ + "static/img/spe_value_pic2.27efa51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/spe_value_pic2.png
// module id = BqkZ
// module chunks = 0